export default "__VITE_ASSET__1f4996b6__"